import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconAddReaction = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M18.65 1C19.0642 1 19.4 1.33579 19.4 1.75V4.6H22.25C22.6642 4.6 23 4.93578 23 5.35C23 5.76421 22.6642 6.1 22.25 6.1H19.4V8.95C19.4 9.36421 19.0642 9.7 18.65 9.7C18.2358 9.7 17.9 9.36421 17.9 8.95V6.1H15.05C14.6358 6.1 14.3 5.76421 14.3 5.35C14.3 4.93578 14.6358 4.6 15.05 4.6H17.9V1.75C17.9 1.33579 18.2358 1 18.65 1Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.67997 6.37997C6.39593 4.66401 8.72327 3.7 11.15 3.7C11.5642 3.7 11.9 4.03579 11.9 4.45C11.9 4.86421 11.5642 5.2 11.15 5.2C9.12109 5.2 7.17529 6.00598 5.74063 7.44063C4.30598 8.87529 3.5 10.8211 3.5 12.85C3.5 14.8789 4.30598 16.8247 5.74063 18.2594C7.17529 19.694 9.12109 20.5 11.15 20.5C13.1789 20.5 15.1247 19.694 16.5594 18.2594C17.994 16.8247 18.8 14.8789 18.8 12.85C18.8 12.4358 19.1358 12.1 19.55 12.1C19.9642 12.1 20.3 12.4358 20.3 12.85C20.3 15.2767 19.336 17.6041 17.62 19.32C15.9041 21.036 13.5767 22 11.15 22C8.72327 22 6.39593 21.036 4.67997 19.32C2.96402 17.6041 2 15.2767 2 12.85C2 10.4233 2.96402 8.09593 4.67997 6.37997Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 12.6C8.82843 12.6 9.5 11.9284 9.5 11.1C9.5 10.2716 8.82843 9.6 8 9.6C7.17157 9.6 6.5 10.2716 6.5 11.1C6.5 11.9284 7.17157 12.6 8 12.6Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3 12.6C15.1284 12.6 15.8 11.9284 15.8 11.1C15.8 10.2716 15.1284 9.6 14.3 9.6C13.4716 9.6 12.8 10.2716 12.8 11.1C12.8 11.9284 13.4716 12.6 14.3 12.6Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.76127 15C7.4729 15 7.28195 15.2957 7.43328 15.5412C8.20145 16.7872 9.57872 17.6178 11.15 17.6178C12.7213 17.6178 14.0985 16.7872 14.8667 15.5412C15.018 15.2957 14.8271 15 14.5387 15H7.76127Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconAddReaction as ReactComponent };
